import React, { useState, useEffect } from 'react';

import "./totales.css"

const Totales = (p) => {
    const ordenes = p.ordenes ?? [];
    const [reporte, setreporte] = useState([]);
    const [totalesUnidades, settotalesUnidades] = useState([]);

    useEffect(() => {
        procesarOrdenes();
    }, [p.ordenes]);

    const procesarOrdenes = () => {
        const len = ordenes.length;
        let hash = {};
        let unidadesTotales = {};
        for (let i = 0; i < len; i++) {
            const area = ordenes[i]?.area ?? "";
            const lenLab = (ordenes[i]?.labores ?? []).length;
            for (let j = 0; j < lenLab; j++) {
                const rancho = ordenes[i].labores[j]?.labor?.rancho_nombre ?? "";
                const keyArea = `${area} - ${rancho}`;
                if (!hash[keyArea]) {
                    hash[keyArea] = {
                        area: area,
                        rancho: rancho,
                        unidades: {}
                    }
                }
                const um = ordenes[i].labores[j]?.labor?.um ?? '';
                if (!hash[keyArea].unidades[um]) {
                    hash[keyArea].unidades[um] = {
                        unidad: um,
                        asignado: 0,
                        realizado: 0
                    };
                }
                if (!unidadesTotales[um]) unidadesTotales[um] = { unidad: um, asignado: 0, realizado: 0 };
                hash[keyArea].unidades[um].asignado += ordenes[i].labores[j]?.asignado ?? 0;
                hash[keyArea].unidades[um].realizado += ordenes[i].labores[j]?.unidades_realizadas ?? 0;
                unidadesTotales[um].asignado += ordenes[i].labores[j]?.asignado ?? 0;
                unidadesTotales[um].realizado += ordenes[i].labores[j]?.unidades_realizadas ?? 0;
            }

        }
        hash = Object.values(hash);
        hash.sort((a, b) => a.area.localeCompare(b.area));
        hash.sort((a, b) => a.rancho.localeCompare(b.rancho));
        unidadesTotales = Object.values(unidadesTotales);
        unidadesTotales.sort((a, b) => a.unidad.localeCompare(b.unidad));
        setreporte(hash);
        settotalesUnidades(unidadesTotales);

    }

    return (
        <div className='col-lg-12  text-center p-1'>
            <div className='col-lg-12 mt-3 h3 text-300 text-center mb-0 p-0'>Totales</div>
            <div className='grid-6'>
                {reporte.map((rep) => (
                    <div key={rep.area + rep.rancho} className='bg-white shadow-sm round-xs columna-dato p-2 text-s'>
                        <div className='col-lg-12 text-bold'>{rep.rancho}</div>
                        <div className='col-lg-12 text-m text-300 mb-1 border-bottom border-warning'>{rep.area}</div>
                        {Object.values(rep.unidades).map((u) => (
                            <React.Fragment key={u.unidad}>
                                <div className='col-lg-12 text-xs text-bold'>{u.unidad}</div>
                                <div className='col-lg-12 text-s text-blue3'><span>Asignado:</span> {+(u.asignado).toFixed(2)}</div>
                                <div className='col-lg-12 text-s border-bottom mb-3 text-green3'><span>Realizado:</span> {+(u.realizado).toFixed(2)}</div>
                            </React.Fragment>

                        ))}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Totales;